import React from "react";
import { SettingRow } from "./SettingRow";

interface ActivityTabProps {
  userPreferences: any;
  updateUserPreferences: (updates: any) => void;
}

export function ActivityTab({
  userPreferences,
  updateUserPreferences,
}: ActivityTabProps) {
  return (
    <div className="settings-section">
      <div className="setting-group">
        <label>Activity confirmations</label>
        <select
          value={userPreferences.confirmationMode ?? "stop"}
          onChange={(e) =>
            updateUserPreferences({
              confirmationMode: e.target.value,
            })
          }
        >
          <option value="never">Never confirm</option>
          <option value="stop">Confirm on stop only</option>
          <option value="both">Confirm on both stop and pause</option>
        </select>
      </div>

      <div className="setting-group">
        <label>Inactivity timeout</label>
        <select
          value={userPreferences.inactivityTimeout ?? 5}
          onChange={(e) =>
            updateUserPreferences({
              inactivityTimeout: Number(e.target.value),
            })
          }
        >
          <option value="0">Off</option>
          <option value="1">1 minute</option>
          <option value="5">5 minutes</option>
          <option value="15">15 minutes</option>
          <option value="30">30 minutes</option>
        </select>
      </div>

      <div className="setting-group">
        <label>Inactivity distance</label>
        <select
          value={userPreferences.inactivityDistance ?? 2}
          onChange={(e) =>
            updateUserPreferences({
              inactivityDistance: Number(e.target.value),
            })
          }
        >
          <option value="0">Off</option>
          {userPreferences.units === "metric" ? (
            <>
              <option value="1">1 km</option>
              <option value="2">2 km</option>
              <option value="3">3 km</option>
              <option value="8">8 km</option>
              <option value="16">16 km</option>
            </>
          ) : (
            <>
              <option value="1">0.5 miles</option>
              <option value="2">1 mile</option>
              <option value="3">2 miles</option>
              <option value="8">5 miles</option>
              <option value="16">10 miles</option>
            </>
          )}
        </select>
      </div>

      <SettingRow
        label="Voice announcements"
        description="Spoken updates during activities"
        checked={userPreferences.voiceAnnouncements || false}
        onChange={(checked) =>
          updateUserPreferences({ voiceAnnouncements: checked })
        }
      />

      <div className="setting-group">
        <label>Auto-save interval</label>
        <select
          value={userPreferences.autoSaveInterval}
          onChange={(e) =>
            updateUserPreferences({
              autoSaveInterval: Number(e.target.value),
            })
          }
        >
          <option value="10">10 seconds</option>
          <option value="30">30 seconds</option>
          <option value="60">1 minute</option>
          <option value="120">2 minutes</option>
        </select>
      </div>
    </div>
  );
}
